import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgImageDemo = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 18,
	height: 14,
	viewBox: "0 0 18 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Frame 564",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Vector",
				d: "M17.8246 5.35013C17.7745 5.30838 17.3237 4.96611 16.3553 4.96611C16.1049 4.96611 15.8461 4.99115 15.5956 5.03289C15.412 3.75561 14.3517 3.13784 14.31 3.10445L14.0512 2.95418L13.8842 3.19628C13.6755 3.52186 13.5169 3.88918 13.4251 4.26485C13.2498 4.99115 13.3583 5.67571 13.7256 6.26009C13.2832 6.51053 12.5652 6.56897 12.4149 6.57732H0.560423C0.251537 6.57732 0.00108959 6.82777 0.00108959 7.13665C-0.0156069 8.17184 0.159706 9.20702 0.518681 10.1838C0.927746 11.2523 1.53717 12.0454 2.3219 12.5296C3.20682 13.0723 4.65107 13.3811 6.27898 13.3811C7.01362 13.3811 7.74827 13.3144 8.47457 13.1808C9.48471 12.9971 10.4531 12.6465 11.3464 12.1373C12.081 11.7115 12.7405 11.1689 13.2999 10.5344C14.2432 9.47417 14.8025 8.28871 15.2116 7.23683C15.27 7.23683 15.3201 7.23683 15.3786 7.23683C16.4054 7.23683 17.0399 6.82777 17.3905 6.47714C17.6243 6.26009 17.7996 5.99294 17.9248 5.6924L17.9999 5.47535L17.8246 5.35013Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_2",
				d: "M1.66249 6.23506H3.24866C3.32379 6.23506 3.39058 6.17662 3.39058 6.09314V4.67393C3.39058 4.5988 3.33214 4.53201 3.24866 4.53201H1.66249C1.58735 4.53201 1.52057 4.59045 1.52057 4.67393V6.09314C1.52892 6.17662 1.58735 6.23506 1.66249 6.23506Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_3",
				d: "M3.84962 6.23506H5.43579C5.51093 6.23506 5.57771 6.17662 5.57771 6.09314V4.67393C5.57771 4.5988 5.51927 4.53201 5.43579 4.53201H3.84962C3.77449 4.53201 3.7077 4.59045 3.7077 4.67393V6.09314C3.71605 6.17662 3.77449 6.23506 3.84962 6.23506Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_4",
				d: "M6.07881 6.23506H7.66498C7.74011 6.23506 7.8069 6.17662 7.8069 6.09314V4.67393C7.8069 4.5988 7.74846 4.53201 7.66498 4.53201H6.07881C6.00368 4.53201 5.93689 4.59045 5.93689 4.67393V6.09314C5.93689 6.17662 5.99533 6.23506 6.07881 6.23506Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_5",
				d: "M3.84962 4.20643H5.43579C5.51093 4.20643 5.57771 4.13964 5.57771 4.0645V2.6453C5.57771 2.57017 5.51927 2.50338 5.43579 2.50338H3.84962C3.77449 2.50338 3.7077 2.56182 3.7077 2.6453V4.0645C3.71605 4.13964 3.77449 4.20643 3.84962 4.20643Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_6",
				d: "M6.07881 4.20643H7.66498C7.74011 4.20643 7.8069 4.13964 7.8069 4.0645V2.6453C7.8069 2.57017 7.74846 2.50338 7.66498 2.50338H6.07881C6.00368 2.50338 5.93689 2.56182 5.93689 2.6453V4.0645C5.93689 4.13964 5.99533 4.20643 6.07881 4.20643Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_7",
				d: "M8.27431 2.16944H9.86047C9.93561 2.16944 10.0024 2.11101 10.0024 2.02752V0.608322C10.0024 0.533187 9.93561 0.4664 9.86047 0.4664H8.27431C8.19917 0.4664 8.13239 0.524839 8.13239 0.608322V2.02752C8.13239 2.10266 8.19917 2.16944 8.27431 2.16944Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_8",
				d: "M10.4865 6.23506H12.0726C12.1478 6.23506 12.2146 6.17662 12.2146 6.09314V4.67393C12.2146 4.5988 12.1561 4.53201 12.0726 4.53201H10.4865C10.4113 4.53201 10.3445 4.59045 10.3445 4.67393V6.09314C10.3529 6.17662 10.4113 6.23506 10.4865 6.23506Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_9",
				d: "M8.24977 6.23506H9.83594C9.91107 6.23506 9.97786 6.17662 9.97786 6.09314V4.67393C9.97786 4.5988 9.91942 4.53201 9.83594 4.53201H8.24977C8.17463 4.53201 8.10785 4.59045 8.10785 4.67393V6.09314C8.10785 6.17662 8.17463 6.23506 8.24977 6.23506Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Vector_10",
				d: "M8.24977 4.20643H9.83594C9.91107 4.20643 9.97786 4.13964 9.97786 4.0645V2.6453C9.97786 2.57017 9.91107 2.50338 9.83594 2.50338H8.24977C8.17463 2.50338 8.10785 2.56182 8.10785 2.6453V4.0645C8.10785 4.13964 8.17463 4.20643 8.24977 4.20643Z",
				fill: "currentColor"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgImageDemo);
export { ForwardRef as ReactComponent };
